import colorpickercontrast from "../../../../assets/videos/colorpickercontrast.mp4";
import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import * as React from 'react';
export default {
  colorpickercontrast,
  ShortCutDisplay,
  React
};